import { jsonProperty, Serializable, SerializationSettings } from 'ts-serializable';
import ComponentLacunasAlternativas from './ComponentLacunasAlternativas';

interface IComponentLacunas {
    codigo: number;
    text: string;
    textAux: string;
    qtdLacunas: number;
    alternativas: ComponentLacunasAlternativas[];
}

class ComponentLacunas extends Serializable {
    @jsonProperty(Number)
    codigo: number = -1;

    @jsonProperty(String)
    text: string = '';

    @jsonProperty(String)
    textAux: string = '';

    @jsonProperty(Number)
    qtdLacunas: number = -1;

    alternativas: ComponentLacunasAlternativas[] = [];

    fromJSON(json: IComponentLacunas, settings?: Partial<SerializationSettings>): this {
        this.codigo = json.codigo;
        this.text = json.text;
        this.textAux = json.textAux;
        this.qtdLacunas = json.qtdLacunas;
        this.alternativas = json.alternativas;
        return this;
    }
}

export default ComponentLacunas;
